export enum Columns {
  Alias = 'alias',
  Site = 'site',
  Firmware = 'firmware',
  Groups = 'groups',
  ContentSource = 'contentSource',
  Power = 'power',
  Playlist = 'playlist',
  PowerSchedule = 'powerSchedule',
  Selection = 'selection',
  Status = 'status',
  Volume = 'volume',
  Warnings = 'warnings',
  ClaimCode = 'claimCode',
  Configuration = 'configuration',
  RowActions = 'rowActions',
}

export type FilterKeys =
  | Columns.Firmware
  | Columns.Groups
  | Columns.Playlist
  | Columns.PowerSchedule
  | Columns.Site
  | Columns.Warnings
  | Columns.Status
  | Columns.ClaimCode
  | Columns.Configuration;

export const FilterKeys = [
  Columns.Firmware,
  Columns.Groups,
  Columns.Playlist,
  Columns.PowerSchedule,
  Columns.Site,
  Columns.Warnings,
  Columns.Status,
  Columns.ClaimCode,
  Columns.Configuration,
] as const;

export const MINUTES_IN_A_DAY = 1440;

export type FilterOptionServerSide = {
  column: FilterKeys;
  label: string;
  value: string;
  id: string;
};

export type FilterOptionsServerSide = {
  [key in FilterKeys]: { all: FilterOptionServerSide[]; enabled: FilterOptionServerSide[] };
};
